import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


/** @type {any} */
const routes = require('./routes.js')
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 捕获路由错误，防止未捕获的 promise rejection
router.onError((error) => {
  console.error('Router error:', error);
});

// 全局导航守卫，处理导航错误
router.beforeEach((to, from, next) => {
  try {
    next();
  } catch (error) {
    console.error('Navigation error:', error);
    next(false);
  }
});

export default router
